import Axios from 'axios';
Axios.defaults.withCredentials = true; // enable axios post cookie, default false
//http://mypharma.suncare.ml
export const client = Axios.create({
    baseURL: 'https://mypharma.suncare.care:4000/api/',
    json: true,
    headers:{
        Authorization : localStorage.getItem("token")
    }
});
